import { Select, SelectProps } from 'antd';
import { makeStyles } from '@mui/styles';

export const SelectControlledInput = (props: SelectProps) => {
  const cls = useStyles();

  return (
    <Select
      {...props}
      className={cls.select}
    />
  );
};

const useStyles = makeStyles({
  select: {
    borderRadius: 8,
    border: '1px solid var(--logo-color)',
    background: 'var(--foreground-color)',
    minWidth: 200,
    height: 36,
    '& > div': {
      borderRadius: '8px !important',
      height: '34px !important',
      border: 'none !important',
      paddingTop: '2px !important',
      paddingLeft: '16px !important',
      backgroundColor: 'transparent !important',
    },
    '& .ant-select-selection-item': {
      color: 'var(--text-color)',
    },
    '& .ant-select-selection-placeholder': {
      color: 'var(--mutted-color)',
    },
    '& svg': {
      color: 'var(--primary-color)',
    },
  },
});
